/**********************************************************************************************************************/
/* FILE: hafas_webapp.js                                                                                              */
/**********************************************************************************************************************/
// instanciate new Webapp if modules are ready
Hafas.ps.sub('/core/serverTime/done/', function() {

  // Wenn forcedLayoutClass gesetzt ist, darf der body nicht die Höhe 100% erhalten.
  // Daher setzen wir eine Klasse in den Body-Tag um das von hier aus zu überschreiben
  if (Hafas.Config.forceLayoutClass) {
    document.body.setAttribute('data-hafas', Hafas.Config.layoutClass);
  }

  var optionModels = {};
  // Options in Abhängigkeit des Mandanten auswählen
  var optionsPath = Hafas.Config.optionsPath;
  // Werte werden in der Core gesetzt
  if (typeof Hafas.Config.isCustomer != 'undefined' && Hafas.Config.isCustomer === true) {
    optionsPath = 'customer/' + Hafas.Config.CustomerName + '/' + Hafas.Config.optionsPath;
  }


  // set lang-attribute depending on selected Language-Object
  Hafas('html', false).setAttribute('lang', Hafas.Config.currentISO);

  // Prüfe, ob SVGs unterstützt werden (-> wird in Hafas.Config.hasSvgSupport als true/false abgelegt)
  Hafas.Config.hasSvgSupport = Hafas.Util.supportsSvg();

  // Base-Template rendern
  if(typeof Hafas.Config.WidgetMode != 'undefined') {
    initAllWidgets();
  }else if(typeof Hafas.Config.webview != 'undefined'){
    startWebview();
  }else{
    if (Hafas.Config.PrivacyPolicy) {
      PrivacyPolicy(renderBaseTemplate);
    } else {
      renderBaseTemplate();
    }
  }

  function renderBaseTemplate() {

    // für right to left Sprachen müssen alles Styles gespiegelt werden.
    if(Hafas.Config.isRTLLanguage)
    {
      if(Hafas.Modules.RTL != undefined)
      {
        Hafas.Modules.RTL.flipCss();
        Hafas.Modules.RTL.flipMapController();
      }
      else
        console.warn("RTL Sprache ist aktiv aber das rtl Module wurde nicht geladen!");
    }

    // Druckansicht anzeigen?
    if(document.body.getAttribute('data-hafas-print') == 'printview'){
      startPrintview();
    }
    // Webapp anzeigen
    else {
      // Für welche Features sollen Optionen geladen & angezeigt werden?
      var initOptions = [];
      if(Hafas.Config.Switches.useTravelplanner && Hafas.Config.TP.useQueryOptions) { initOptions.push('TP'); }
      if(Hafas.Config.Switches.useStationboard && Hafas.Config.SQ.useQueryOptions) { initOptions.push('SQ'); }
      if(Hafas.Config.Switches.useProximity && Hafas.Config.Proximity.useQueryOptions) { initOptions.push('Proximity'); }
      if(Hafas.Config.Switches.useHimSearch && Hafas.Config.HimSearch.useQueryOptions) { initOptions.push('HimSearch'); }
      if(Hafas.Config.Switches.useReachability && Hafas.Config.Reachability.useQueryOptions) { initOptions.push('Reachability'); }

      var startCallback = startWebapp;
      if(Hafas.Config.startCallback == 'startWidgetGenerator'){
        startWidgetGenerator();
      }else {
        var model = {
          optionList: initOptions,
          callback: startCallback
        };
        initAllOptions(model);

        Hafas.Modules.Render.render({
          file: 'common.base.html',
          target: 'HFS_WebApp',
          template: 'Common_WebappBase',
          model: {}
        });
      }

    }
  }

  function initAllWidgets(){
      var widgets = Hafas.Config.Widgets;
      Hafas.Config.WidgetInstances = [];
      new HafasWidgets();
      for(var w=0; w < widgets.length;w++){
         var wgt = widgets[w];
         wgt.index = w;
         Hafas.ps.pub('/widgets/init',[wgt]);
      }
  }

  function initAllOptions(params) {
    var optionList = params.optionList;
    var callback = params.callback;
    var optionCount = optionList.length;
    for(var i = 0; i < optionCount; i++) {
      var application = optionList[i];
      var myOptions = Hafas.Core.newType("hafasRequest", {
        requestType: 'customUrl',
        method: 'get',
        app: application,
        url: optionsPath + 'options_' + application + '.json?v=' + Hafas.Core.getAntiCacheParam(),
        callback: function(data) {
          optionCount--;
          optionModels[data.application] = {questionList: data.questionList};
          if(optionCount == 0) {
            callback({options: optionModels});
          }
        }.bind(this), errorCallback: Hafas.bind(function(data) {
          throw error(data);
        }, this)
      });
    }
  }

  function startWebapp(params) {
    new HafasWebapp(params);
  }

  function startWebview() {
    new HafasWebview();
  }

  function PrivacyPolicy(callback) {
    new HafasPolicy(callback);
  }

  function startPrintview() {
    new HafasWebappPrintview();
  }

  function startWidgetGenerator(){
    new HafasWidgetGenerator();
  }
});
